'use client';

import { useSetAtom } from 'jotai/react';
import { isPageVisibleAtom } from '@/stores/pageVisible';
import { useEffect } from 'react';

const GlobalPageVisible = () => {
  const setIsPageVisible = useSetAtom(isPageVisibleAtom);

  useEffect(() => {
    const controller = new AbortController();
    document.addEventListener(
      'visibilitychange',
      () => {
        setIsPageVisible(document.visibilityState === 'visible');
      },
      {
        signal: controller.signal,
      }
    );

    return () => controller.abort();
  }, [setIsPageVisible]);

  return null;
};

export default GlobalPageVisible;
